// Small secondary "Logged by" line shown beside the Unlinked badge on timesheet rows.
// Reads enrichment fields the backend adds to unlinked timesheets.
export function LoggedByHint({ t, testid }) {
  if (!t?.unlinked) return null;
  const name = t.logged_by_name;
  const candidates = Array.isArray(t.logged_by_candidates) ? t.logged_by_candidates : [];
  const others = Math.max(0, candidates.length - 1);
  const date = t.logged_at ? new Date(t.logged_at).toLocaleDateString("en-GB") : null;
  const importRef = t.import_ref;
  if (!name && !importRef) {
    return <div data-testid={testid} className="text-[11px] text-zinc-400">Logger unknown</div>;
  }
  return (
    <div data-testid={testid} className="text-[11px] text-zinc-500">
      {name && (
        <span>
          Logged by <span className="text-zinc-700 font-medium">{name}</span>
          {others > 0 ? ` or ${others} other${others > 1 ? "s" : ""}` : ""}
          {date ? ` · ${date}` : ""}
        </span>
      )}
      {importRef && <span className="text-zinc-400">{name ? " · " : ""}Import: {importRef}</span>}
    </div>
  );
}
